import { Reducer } from 'react';
import { DefaultValues } from 'react-hook-form';

import { UserBankDetailsFormSchema } from 'components/UserBankDetailsForm/schema';

import { ReceiptInformationFormSchema } from '../NewExpenseClaimRequestStepper/steps/ReceiptInformation/components/ReceiptInformationForm/schema';

export type State = {
  recipientInformation: DefaultValues<UserBankDetailsFormSchema>;
  receiptInformation: DefaultValues<ReceiptInformationFormSchema>;
};

export type Action =
  | {
      type: 'SUBMIT_RECIPIENT_INFORMATION';
      payload: UserBankDetailsFormSchema;
    }
  | {
      type: 'SUBMIT_RECEIPT_INFORMATION';
      payload: ReceiptInformationFormSchema;
    };

export const newExpenseClaimRequestReducer: Reducer<State, Action> = (
  state,
  action,
) => {
  switch (action.type) {
    case 'SUBMIT_RECIPIENT_INFORMATION':
      return {
        ...state,
        recipientInformation: action.payload,
      };
    case 'SUBMIT_RECEIPT_INFORMATION':
      return {
        ...state,
        receiptInformation: action.payload,
      };
    default:
      return state;
  }
};
